import openseadragon from 'openseadragon';

if (!window.image_zoom_embed_context) throw new Error('Global `image_zoom_embed_context` has no value');
const { tile_data } = window.image_zoom_embed_context;

const embed = document.getElementById('js-image-zoom-embed');
const loading_indicator = document.getElementById('js-image-zoom-loading-indicator');

function init() {
    const viewer = openseadragon({
        element: embed,
        showNavigationControl: false,
        // debugMode: true,
        // debugGridColor: 'lime',
        // preserveViewport: true,
        tileSources: {
            width: tile_data.options.image_width,
            height: tile_data.options.image_height,
            maxLevel: tile_data.options.max_level,
            minLevel: tile_data.options.min_level,
            tileSize: tile_data.options.tile_size,
            tileOverlap: tile_data.options.tile_overlap,
            getTileUrl: function (level, column, row) {
                let tile;
                for (let i=0; i<tile_data.levels.length; i++) {
                    const level_obj = tile_data.levels[i];
                    if (level_obj.level === level) {
                        for (let j=0; j<level_obj.tiles.length; j++) {
                            const tile_obj = level_obj.tiles[j];
                            if (tile_obj.row === row && tile_obj.column === column) {
                                tile = tile_obj;
                            }
                        }
                    }
                }

                if (tile) {
                    return tile.url;
                } else {
                    throw new Error(`Cannot find tile for level ${level}, column ${column}, row ${row}`);
                }
            }
        },
    });

    // Hide the loading screen once the tile-sets have loaded
    viewer.world.addHandler('add-item', function(addItemEvent) {
        const tiledImage = addItemEvent.item;
        tiledImage.addHandler('fully-loaded-change', hide_loading_indicator);
    });

    let is_loading_indicator_visible = true;
    function hide_loading_indicator() {
        if (!is_loading_indicator_visible) return;
        is_loading_indicator_visible = false;

        // In case part of the indicator is still visible, we fade it out before
        // hiding it completely
        loading_indicator.style.transition = 'opacity 0.5s';
        loading_indicator.style.opacity = '0';
        loading_indicator.addEventListener('transitionend', () => {
            loading_indicator.style.display = 'none';
        });
    }

    function zoom_in() {
        // Adapted from
        // https://github.com/openseadragon/openseadragon/blob/a6e10e4ac4d89fb5ded7684222c18d7c1162a0bb/src/viewer.js#L3441-L3449
        if (viewer.viewport) {
            viewer.viewport.zoomBy(
                viewer.zoomPerClick / 1.0
            );
            viewer.viewport.applyConstraints();
        }
    }

    function zoom_out() {
        // Adapted from
        // https://github.com/openseadragon/openseadragon/blob/a6e10e4ac4d89fb5ded7684222c18d7c1162a0bb/src/viewer.js#L3452-L3460
        if (viewer.viewport) {
            viewer.viewport.zoomBy(
                1.0 / viewer.zoomPerClick
            );
            viewer.viewport.applyConstraints();
        }
    }

    // Allow the parent window to send commands in
    window.addEventListener('message', (message) => {
        if (message.data && message.data.target === 'IMAGE_ZOOM_EMBED') {
            if (message.data.action === 'ZOOM_IN') {
                zoom_in();
            } else if (message.data.action === 'ZOOM_OUT') {
                zoom_out();
            } else {
                throw new Error('Unknown message received: ' + JSON.stringify(message.data));
            }
        }
    });
}

init();
